import { Region } from '../models/region';

export interface IRegionService {
    getRegionsByCountry(countryCode: string): ng.IPromise<Region[]>;
}

export class RegionService implements IRegionService {
    static $inject = ['$http'];

    constructor(private _$http: ng.IHttpService) { }

    getRegionsByCountry(countryCode: string): ng.IPromise<Region[]> {
        return this._$http.get<Region[]>(`/getRegions?countryCode=${countryCode}`).then(response => {
            return response.data;
        });
    }
}

angular
    .module('deliveryCreate.app')
    .service('RegionService', RegionService);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/directives/consigneeSearch/services/regionService.ts
 **/